import { ReactNode, useState } from 'react';

import { EmptyState, MobileTableCard } from '@/shared/design-system';

import { CardList, EmptyCard } from './mobile-card-list.styled';

export interface MobileCardListItem {
  value: string;
  title: string;
  subtitle?: string;
  startIcon?: ReactNode;
  badge?: ReactNode;
  content: ReactNode;
  toggleLabel?: string;
}

interface MobileCardListProps {
  items: MobileCardListItem[];
  defaultValue?: string | null;
  onValueChange?: (_value: string | null) => void;
  emptyMessage: string;
}

export const MobileCardList = ({
  items,
  defaultValue = null,
  onValueChange,
  emptyMessage,
}: MobileCardListProps) => {
  const [openValue, setOpenValue] = useState<string | null>(defaultValue);

  if (items.length === 0) {
    return (
      <EmptyCard>
        <EmptyState variant="tertiary" title={emptyMessage} />
      </EmptyCard>
    );
  }

  const toggle = (value: string) => {
    const next = openValue === value ? null : value;
    setOpenValue(next);
    onValueChange?.(next);
  };

  return (
    <CardList>
      {items.map((item) => (
        <MobileTableCard
          key={item.value}
          title={item.title}
          subtitle={item.subtitle}
          startIcon={item.startIcon}
          badge={item.badge}
          open={openValue === item.value}
          onToggle={() => toggle(item.value)}
          toggleLabel={item.toggleLabel ?? `Toggle ${item.title}`}
        >
          {item.content}
        </MobileTableCard>
      ))}
    </CardList>
  );
};
